var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"trigger":"hover","width":"300px","placement":"bottom-start"}},[_vm._t("hoverRef",null,{"slot":"reference"}),_c('div',{staticClass:"mb-10"},[_c('a',{staticClass:"black-text",staticStyle:{"text-decoration":"underline"},attrs:{"href":_vm.filePath}},[_vm._v("Download example csv")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }